const linkManual = process.env.REACT_APP_LINK_MANUAL;
const PATH = {
  login: '/login',
  forgot_password: '/forgot-password',
  reset_password: '/reset-password',
  reset_password_success: '/reset-password-success',
  home: '/',
  student_management: '/student-management',
  student_management_new: 'new',
  student_management_edit: 'edit',
  coach_management: '/coach-management',
  coach_management_new: 'new',
  coach_management_edit: 'edit',
  mentor_management: '/mentor-management',
  mentor_management_new: 'new',
  mentor_management_edit: 'edit',
  // Screens the mentor themself uses. Distinct from `mentor_management`, which
  // is the admin screen for managing mentor accounts.
  mentor_coach_management: '/mentor-coach-management',
  mentor_lesson_management: '/mentor-lesson-management',
  mentor_lesson_progress: ':id/progress',
  lesson: '/lesson',
  lesson_new: 'new',
  lesson_edit: 'edit',
  forbidden: '/403',
  not_found: '/404',
  internal_server_error: '/500',
  version_management: '/version-management',
  maintain: '/503',
  chat: '/chat',
  chat_contact: 'contact',
  chat_conversation: 'conversation',
  manual: linkManual || 'https://art-shift.jp/material/manual4coach.pdf',
  gift: '/gift',
  gift_new: 'new',
  gift_edit: 'edit',
  graduation: '/graduation',
  graduation_new: 'new',
  graduation_edit: 'edit',
  plan: '/plan',
  plan_new: 'new',
  plan_edit: 'edit',
  payment: '/payment',
  register_account: '/register-account',
  user_management: '/user-management',
  user_management_edit: 'edit',
  profile: '/profile',
  profile_change_plan: '/profile/change-plan',
};

export default PATH;